export default function DashboardApp() {
  return (
    <div>DashboardApp | this feature will be added later (take code from admin panel on azure)</div>
  );
}
